import React from "react";
import "./Receiver_info_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
// import Cancel_Order_btn from "../../../common-components/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { useNavigate } from "react-router-dom";
import Cancel_Order_btn from "../../../../../../Common-Component/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { IDS } from "../../../../../../../utils/common";
// import Cancel_Order_btn from "../../../common_components/common_btn/cancel_Order_btn/Cancel_Order_btn";

function Receiver_info_holder({ order, showCancelBtn }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/cancel-order/${order?.id}`);
  };

  const handleClickReturn = () => {
    navigate(`/return-order/${order?.id}`);
  };
  return (
    <>
      <section className="Receiver_info_holder">
        <div className="text_holder">
          <h4>{order?.order?.users_address?.user?.first_name}</h4>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faPhone} />
              </div>
            </div>
            <p> {order?.order?.users_address?.mobile_number}</p>
          </div>

          <p>Apartment</p>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faLocationDot} />
              </div>
            </div>
            <p>
              {" "}
              {order?.order?.users_address?.flat_home_bldg},
              {order?.order?.users_address?.col_land_strt},
              {order?.order?.users_address?.society_name} ,
              {order?.order?.users_address?.area_name},
              {order?.order?.users_address?.apt_number},{" "}
              {order?.order?.users_address?.floor}
            </p>
          </div>
          {Number(order?.order_status_id) === Number(IDS.order_status.Ordered) && (
            <Cancel_Order_btn btnText={"Cancel Order"} onClick={handleClick} />
          )}

          {Number(order?.order_status_id) === Number(IDS.order_status.Deliverd) && (
            <Cancel_Order_btn btnText={"Return Order"} onClick={handleClickReturn} />
          )}
        </div>
      </section>
    </>
  );
}

export default Receiver_info_holder;
